import { getStorage, removeStorage, setStorage , getCookie } from "../utils"
import { getPublicKey, getServerTime } from '@api'
import { JSEncrypt } from 'jsencrypt'
import { aesKey, baseApi, retryDelay } from '@base/settings'
import $http from '@config/http'
import { Encrypt } from '@/utils/aesCrypt'
import store from '../store'



//区分网关地址开头
export const checkURL = path => {
  let judgeArr = ['/simPaperGw/moniexam/theme/getMoniExamTheme']
  let regx = judgeArr.some((item) => item === path) ? '+' : '+'
  return regx + path
}

// 默认：'/simPaperGw/moniexam'； 需要qzCloud在接口加上'/qzCloud'
export const checkBaseApi = path => {
  return path.indexOf(baseApi[1]) > -1 ? '' :baseApi[0]
}

const createParams = async (resourcePath, params, sid) => {
  const source = 'pc'
  let PubKey = getStorage('publicKey')
  let ServerTime = await getServerTime()

  //获取和设置公钥
  if (!PubKey) {
    PubKey = await getPublicKey()
    setStorage('publicKey', PubKey)
  }
  const { href } = window.location
    let requestOrigin=''
    const istishuashua = store.getters.isfromTishuashua
    const ischarge = (href.indexOf('/paidExam') > -1)|| (href.indexOf('/ordinaryExam') > -1)
    if(istishuashua){
      requestOrigin= 'pc_brush'
    }else if(ischarge){
      requestOrigin= 'pc_charge'
    }else{
      requestOrigin= 'pc_free'
    }

  //网关请求params参数
  let param = {
    source,
    ...params,
    requestOrigin,
    time: parseInt(ServerTime)
  }

  //AES参数加密
  let paramStr = JSON.stringify(param)
  let aesStr = Encrypt(paramStr)
  let encrypt = new JSEncrypt()
  encrypt.setPublicKey(PubKey)

  return {
    params: aesStr,
    domain: 'chinaacc',
    resourcePath: checkURL(checkBaseApi(resourcePath) + resourcePath),
    platform: '',
    appType: '',
    appVersion: '',
    publicKey: PubKey,
    aesKey: encrypt.encrypt(aesKey),
    sid: sid
  }
}

//构造网关请求
export const setHttpData = async (resourcePath, params, sid = '') => {
  let reqQuery = await createParams(resourcePath, params, sid)
  // $http.post('/', reqQuery) 可以去掉 / ,但是为了和服务器时间等接口区分，加上 /
  return new Promise((resolve, reject) => {
    $http.post('/', reqQuery).then(res => {
      const { data } = res
      let retryDelays = retryDelay || 3000
      if (!data.success && data.reRequest) {
        const backOff = new Promise(resolve1 => {
          setTimeout(function () {
            removeStorage('publicKey')
            resolve1()
          }, retryDelays)
        })
        return backOff.then(() => {
          setHttpData(resourcePath, params, sid)
        })
      } else {
        resolve(data)
      }
    }).catch(e=>{
      reject(e)
    })
  })
}

const createDoormanParams = async (resourcePath, params) => {
  const source = 'pc'
  let PubKey = getStorage('publicKey')
  let ServerTime = await getServerTime()

  //获取和设置公钥
  if (!PubKey) {
    PubKey = await getPublicKey()
    setStorage('publicKey', PubKey)
  }

  //网关请求params参数
  let param = {
    source,
    ...params,
    time: parseInt(ServerTime)
  }

  //AES参数加密
  let paramStr = JSON.stringify(param)
  let aesStr = Encrypt(paramStr)
  let encrypt = new JSEncrypt()
  encrypt.setPublicKey(PubKey)

  return {
    params: aesStr,
    domain: 'chinaacc',
    resourcePath,
    platform: '',
    appType: '',
    appVersion: '',
    publicKey: PubKey,
    aesKey: encrypt.encrypt(aesKey),
    sid: getCookie('sid') || null
  }
}

//构造网关请求
export const doorman = async (resourcePath, params) => {
  let reqQuery = await createDoormanParams(resourcePath, params)

  return new Promise((resolve, reject) => {
    $http.post(`/chinaacc@${resourcePath}`, reqQuery).then(res => {
      const { data } = res
      let retryDelays = retryDelay || 3000
      if (!data.success && data.reRequest) {
        const backOff = new Promise(resolve1 => {
          setTimeout(function () {
            removeStorage('publicKey')
            resolve1()
          }, retryDelays)
        })
        return backOff.then(() => {
          setHttpData(resourcePath, params, sid)
        })
      } else {
        resolve(data)
      }
    }).catch(e=>{
      reject(e)
    })
  })
}

